import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

const rewardsDashboardUrl = "/api/v1/rewards/dashboard";
const rewardsVouchersUrl = "/api/v1/rewards/voucher";

export interface RewardsDashboardApiParameter extends ApiParameter {
    customerId?: string;
}

export interface RewardsVouchersApiParameter extends ApiParameter {
    customerId?: string;
}

export interface RewardsDashboardResponse {
    uri: string | null;
    rewardPeriod: string;
    rewardPeriodDisplay: string;
    currentSpending: number;
    currentSpendingDisplay: string;
    amountNeededToLevelUp: number;
    amountNeededToLevelUpDisplay: string;
    currentLevel: string;
    nextLevel: string;
    totalAvailableVoucher: number;
    totalAvailableVoucherDisplay: string;
    bonusRewards: number;
    bonusRewardsDisplay: string;
    isRewardCustomer: boolean;
    amountToTwoPctTierDisplay: string;
    amountToThreePctTierDisplay: string;
    amountToFourPctTierDisplay: string;
    properties: {};
}

export interface RewardsVoucherResponse {
    voucherAmount: number;
    voucherAmountDisplay: string;
    voucherCode: string;
    statusRaw: "AVAILABLE" | "REDEEMED" | "EXPIRED";
    status: number;
    voucherPeriod: string;
    issueDate: string;
    expiresDate: string;
    redemptionDate?: string;
}

export interface RewardsVouchersResponse {
    uri: string | null;
    availableVouchers: RewardsVoucherResponse[];
    redeemedExpiredVouchers: RewardsVoucherResponse[];
    properties: {};
}

export interface TransformedVoucher {
    id: string;
    status: "available" | "redeemed" | "expired";
    display_status?: string;
    amount: number;
    amountDisplay: string;
    code: string;
    period: string;
    issuedDate: string;
    rawIssueDate: string;
    expirationDate: string;
    redemptionDate?: string;
    isExpiringSoon?: boolean;
}

export function getRewardsDashboard(parameter: RewardsDashboardApiParameter): Promise<RewardsDashboardResponse> {
    return get<RewardsDashboardResponse>(rewardsDashboardUrl, parameter);
}

export function getRewardsVouchers(parameter: RewardsVouchersApiParameter): Promise<RewardsVouchersResponse> {
    return get<RewardsVouchersResponse>(rewardsVouchersUrl, parameter);
}
